/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/date/date.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatNativeDateModule } from '@angular/material/core';
import { DateAdapter } from '@angular/material/core';
import { DatePbAdapter } from "./datepb.dateadapter";
import { DatePbPipe } from "./datepb.pipe";
import * as i0 from "@angular/core";
export class DateModule {
    constructor() {
    }
}
DateModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    DatePbPipe,
                ],
                imports: [
                    CommonModule,
                    MatNativeDateModule,
                ],
                exports: [
                    DatePbPipe,
                ],
                providers: [
                    {
                        provide: DateAdapter,
                        useClass: DatePbAdapter,
                    },
                ],
            },] },
];
/** @nocollapse */
DateModule.ctorParameters = () => [];
/** @nocollapse */ DateModule.ɵmod = i0.ɵɵdefineNgModule({ type: DateModule });
/** @nocollapse */ DateModule.ɵinj = i0.ɵɵdefineInjector({ factory: function DateModule_Factory(t) { return new (t || DateModule)(); }, providers: [
        {
            provide: DateAdapter,
            useClass: DatePbAdapter,
        },
    ], imports: [[
            CommonModule,
            MatNativeDateModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DateModule, { declarations: [DatePbPipe], imports: [CommonModule,
        MatNativeDateModule], exports: [DatePbPipe] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(DateModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DatePbPipe,
                ],
                imports: [
                    CommonModule,
                    MatNativeDateModule,
                ],
                exports: [
                    DatePbPipe,
                ],
                providers: [
                    {
                        provide: DateAdapter,
                        useClass: DatePbAdapter,
                    },
                ],
            }]
    }], function () { return []; }, null); })();
//# sourceMappingURL=data:application/json;base64,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